import { render } from "./LoadingSplash.vue?vue&type=template&id=5196004e&scoped=true"
const script = {}

import "./LoadingSplash.vue?vue&type=style&index=0&id=5196004e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5196004e"]])

export default __exports__